var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "image-card-box",
      style: { backgroundImage: _vm.backgroundImage, maxWidth: _vm.maxWidth }
    },
    [
      _vm.title || _vm.text
        ? [
            _c("div", { staticClass: "image-content" }, [
              _vm.title
                ? _c("div", { staticClass: "image-title" }, [
                    _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.text
                ? _c("div", { staticClass: "image-text" }, [
                    _vm._v("\n        " + _vm._s(_vm.text) + "\n      ")
                  ])
                : _vm._e()
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-730c594a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-730c594a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/materials/SquareImage.vue
// module id = 1568
// module chunks = 0